"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentManager = void 0;
const DataSchemaContext_1 = require("../core/DataSchemaContext");
/**
 * React, Vue 通用的部分：管理 ui 编辑框组件
 *
 * 泛型 `COMPONENT` 是不同类型框架的实现，例如 React 是 `React.ComponentType<any>`，Vue 是 `Vue.ComponentOptions<Vue>`
 */
class ComponentManager {
    constructor() {
        /** 编辑框组件大全 */
        this.components = {};
    }
    /** 获取 编辑框组件 */
    get(uiType) {
        return this.components[uiType];
    }
    register(arg0) {
        const arr = Array.isArray(arg0) ? arg0 : [arg0];
        for (let i = 0; i < arr.length; i++) {
            const cm = Object.assign({}, arr[i]);
            const settingsSchema = cm.settingsSchema && new DataSchemaContext_1.DataSchemaContext(cm.settingsSchema).getSchema();
            if (settingsSchema) {
                // 检查 settingsSchema.type
                if (settingsSchema.type !== 'object') {
                    throw new Error('settingsSchema is provided, its type must be "object"');
                }
                // 没有提供 defaultSettings，就自动根据 settingsSchema 生成！
                if (!cm.defaultSettings) {
                    const tempCtx = new DataSchemaContext_1.DataSchemaContext(settingsSchema);
                    const rootStub = tempCtx.makeRootStubOf({});
                    cm.defaultSettings = rootStub.getDefaultValue();
                }
            }
            this.components[cm.id] = cm;
        }
    }
}
exports.ComponentManager = ComponentManager;
//# sourceMappingURL=ComponentManager.js.map